<template>
  <div class="home" @click="handlerCancleSelect">
    <div class="home__top1">
      <div class="inner">
        <div class="header">
          <img src="../assets/images/logo.png" alt />
          <div class="header__language" @click="handlerShowLangs">
            {{ $t("called") }}
            <img
              src="../assets/images/down.png"
              class="language_img"
              @click="handlerShowLangs"
            />
            <ul v-if="showLangs">
              <li
                v-for="(item, index) in Object.keys(langs)"
                :key="index"
                :class="{ active: curLang === item }"
                @click="setLang(item, $event)"
              >
                {{ langs[item] }}
              </li>
            </ul>
          </div>
        </div>
        <div class="share">
          <img
            class="shareIcon"
            @click="handlerShowShare()"
            src="../assets/images/share.png"
            alt
          />
          <div
            :class="{
              shareItems: true,
              hidden: !showShare,
              addthis_inline_share_toolbox: true,
            }"
          ></div>
        </div>
        <div class="content">
          <div :class="{ globel: true, 'globel-wap': setwapClass }">
            <h2 v-html="$t('gloaleTitle')"></h2>
            <span v-html="$t('gloaleText')"></span>
          </div>

          <span class="btn" v-if="isWap" @click="toWapChat()">
            {{ $t("contact") }}
          </span>
          <span class="btn" v-else onClick="showChatBOx()">
            {{ $t("contact") }}
          </span>
        </div>
      </div>
    </div>
    <move style="margin: 10px 0" />
    <div class="home__services">
      <div class="inner">
        <div class="inner__label">
          <span class="big">{{ $t("services") }}</span>
          <span class="small">{{ $t("serviceContent") }}</span>
        </div>
        <div class="inner__service">
          <!-- <span class="inner__service--matching">{{$t('matching')}}</span> -->
          <img src="../assets/images/service.png" class="service-img" alt />
          <ul class="caselist">
            <li v-for="(item, index) in 4" :key="index">
              <img
                :src="require(`../assets/images/service-0${item}.png`)"
                alt
              />
              <div class="info">
                <span
                  class="info__title"
                  v-html="$t('serviceItems')[index].title"
                ></span>
                <span
                  class="info__desc"
                  v-html="$t('serviceItems')[index].desc"
                ></span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="home__tags">
      <div class="inner">
        <div class="content">
          <ul class="tags">
            <li v-for="(item, index) in 4" :key="index">
              <img :src="require(`../assets/images/0${item}.png`)" alt />
              <span class="title" v-html="$t('items')[index].title"></span>
              <span class="desc" v-html="$t('items')[index].desc"></span>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="home__people">
      <div class="inner">
        <div class="inner__label">
          <span class="big">{{ $t("teachLabel") }}</span>
        </div>
        <div class="content">
          <ul class="people-list">
            <li v-for="(item, index) in 5" :key="index">
              <img :src="require(`../assets/images/people-${item}.png`)" alt />
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="home__end">
      <div class="inner">
        <div class="content">
          <span class="big">{{ $t("endLabel") }}</span>
          <span class="small" v-html="$t('endSmall')"></span>
        </div>
      </div>
    </div>
    <div class="home__last">
      <div class="inner">
        <div class="content">
          <span class="big">{{ $t("just") }}</span>
          <span class="small" v-html="$t('justval')"></span>
          <span class="btn" v-if="isWap" @click="toWapChat()">
            {{ $t("letStart") }}
          </span>
          <span class="btn" v-else onClick="showChatBOx()">
            {{ $t("letStart") }}
          </span>
        </div>
      </div>
    </div>
    <div class="home__footer">
      <div>
        BBTALK(TM) Copyright© 2005 - 2019 BBTALK Corporation. All rights
        reserved.
      </div>
      <div style="margin-top: 10px">
        <a href="https://beian.miit.gov.cn" class="open" target="_blank"
          >ICP备案/许可证号：蜀 ICP 备 17037340号-1</a
        >
      </div>
    </div>
    <img
      src="../assets/images/chat.png"
      class="new-chaticon"
      v-if="isWap"
      @click="toWapChat"
    />
    <img
      src="../assets/images/chat.png"
      class="new-chaticon"
      v-else
      onClick="showChatBOx()"
      alt
    />
  </div>
</template>

<script>
import move from "./Video.vue";
export default {
  name: "home",
  components: { move },
  data() {
    return {
      list: [],
      isWap: false,
      langCode: 1,
      langs: {},
      curLang: "",
      showLangs: false,
      showShare: false,
      setwapClass: false,
    };
  },
  created() {
    this.isWap = this.$root.$el.clientWidth <= 640 ? true : false;
    let lang = this.$i18n.locale;
    switch (lang) {
      case "zh":
        this.langCode = 1;
        break;
      case "en":
        this.langCode = 2;
        break;
      case "ja":
        this.langCode = 8;
        break;
    }
    this.curLang = this.$i18n.locale;
    this.langs = this.$i18n.messages[this.curLang].langs;
    this.handlerSetWapClass(lang);
  },
  mounted() {
    // add chat js
    let script = document.createElement("script");
    script.type = "text/javascript";
    script.src = `${this.env(
      "BASEURL"
    )}/static/js/service.js?key=AF03DF03D6925CDC8828633A096D0CF3&lang=${
      this.langCode
    }&title=Tripmate`;
    script.id = "service";

    document.getElementsByTagName("head")[0].appendChild(script);
    // document.title = this.$t("pageTitle");
  },
  methods: {
    handlerSetWapClass(lang) {
      if (this.isWap && lang == "en") {
        this.setwapClass = true;
      } else {
        this.setwapClass = false;
      }
    },
    env(key) {
      return process.env[`VUE_APP_${key}`];
    },
    handlerCancleSelect(event) {
      if (
        event.target.className !== "header__language" &&
        event.target.className !== "language_img" &&
        event.target.className !== "shareIcon"
      ) {
        this.showLangs = this.showShare = false;
      }
    },
    handlerShowShare() {
      this.showShare = !this.showShare;
      this.showLangs = false;
    },
    handlerShowLangs(event) {
      event.stopPropagation();
      this.showLangs = !this.showLangs;
      this.showShare = false;
    },
    toWapChat() {
      window.location.href = `${this.env(
        "BASEURL"
      )}?key=AF03DF03D6925CDC8828633A096D0CF3&lang=${
        this.langCode
      }&title=Tripmate`;
    },

    setLang(locale, event) {
      event.stopPropagation();
      this.$i18n.locale = this.curLang = locale;
      this.langs = this.$i18n.messages[this.curLang].langs;

      this.handlerSetWapClass(locale);
      this.showLangs = false;
      // document.title = this.$t("pageTitle");
    },
  },
};
</script>
<style lang="stylus" scoped>
@import '../styles/utils/mixins';

.service-img {
  object-fit: cover;
  width: 100%;
  margin-bottom: 2rem;
}

.caselist {
  display: flex;
  flex-flow: row;
  justify-content: space-around;

  li {
    list-style: none;
    display: flex;
    flex-flow: row;
    align-items: flex-start;
    margin-right: 0.5rem;

    // width: 25%;
    img {
      margin-right: 0.5rem;
      object-fit: cover;
    }

    .info {
      display: flex;
      flex-flow: column;
      align-items: flex-start;

      .info__title {
        font-family: 'MicrosoftYaHei';
        font-size: 18px;
        font-weight: normal;
        font-stretch: normal;
        // line-height: 80px;
        letter-spacing: 0px;
        color: #222222;
      }

      .info__desc {
        font-family: 'MicrosoftYaHei';
        font-size: 14px;
        font-weight: normal;
        letter-spacing: 0px;
        color: #666666;
      }
    }
  }
}

.new-chaticon {
  position: fixed;
  right: 1rem;
  bottom: 4rem;
  cursor: pointer;
  width: 100px;
  object-fit: cover;
  z-index: 99;
}

+b(inner) {
  width: 80%;
  margin: 0 auto;
  display: flex;
  flex-flow: column;
  flex: 1;

  .share {
    position: relative;
    z-index: 99;

    .shareIcon {
      width: 80px;
      position: fixed;
      right: 1rem;
      top: 1rem;
      z-index: 99;
      cursor: pointer;
    }

    .shareItems {
      position: fixed;
      top: 100px;
      right: 10px;
      display: flex;
      flex-flow: row;
      flex-wrap: wrap;
      background: #ffffff;
      padding: 0.5rem;
      border-radius: 0.25rem;
      color: #666666;
      font-size: 14px;
      line-height: 30px;
      max-width: 300px;
      justify-content: space-around;

      &.hidden {
        display: none;
      }

      span {
        img {
          width: 60px !important;
          object-fit: cover;
        }
      }

      .at-resp-share-element {
        .at-share-btn-elements {
          a {
            span {
              &.at-label {
                display: none !important;
              }
            }
          }
        }
      }
    }
  }

  .header {
    display: flex;
    flex-flow: row;
    align-items: center;
    justify-content: space-between;
    font-size: 18px;
    color: #ffffff;
    padding: 0.9rem 0;

    img {
      // width: 380px;
      object-fit: cover;
    }

    +e(language) {
      display: flex;
      flex-flow: row;
      align-items: center;
      position: relative;
      cursor: pointer;

      img {
        width: 12px;
        object-fit: cover;
        margin-left: 0.25rem;
      }

      ul {
        position: absolute;
        width: 80px;
        background: #ffffff;
        padding: 0.5rem;
        bottom: -10.5rem;
        right: -0.5rem;
        border-radius: 0.25rem;

        li {
          list-style: none;
          color: #666666;
          font-size: 14px;
          line-height: 40px;

          &.active {
            color: rgba(138, 0, 145, 1);
          }
        }
      }
    }
  }

  +e(label) {
    display: flex;
    flex-flow: column;
    color: #333333;
    padding: 2.5rem 0;

    .big {
      font-family: 'MicrosoftYaHei';
      font-size: 36px;
      font-weight: bold;
      font-stretch: normal;
      letter-spacing: 0px;
      margin-bottom: 0.5rem;
    }

    .small {
      font-size: 24px;
    }
  }

  +e(service) {
    background-size: cover;
    position: relative;
    display: flex;
    flex-flow: column;

    .bg {
      object-fit: cover;
      width: 100%;
    }

    +m(line1) {
      position: absolute;
      font-size: 30px;
      display: flex;
      flex-flow: row;
      justify-content: space-around;
      top: 50%;
      left: 0;
      width: 100%;

      span {
        &:first-child {
          margin-right: 12rem;
        }

        &:last-child {
          margin-left: 15rem;
        }
      }
    }

    +m(line2) {
      position: absolute;
      font-size: 30px;
      display: flex;
      flex-flow: row;
      justify-content: space-around;
      top: 100%;
      left: 0;
      width: 100%;
    }
  }

  .content {
    flex: 1;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    // font-size: 50px;
    color: #ffffff;

    .globel {
      text-transform: uppercase;

      p {
        margin: 0;
        padding: 0;
      }
    }

    .btn {
      margin-top: 2rem;
      padding: 0 4rem;
      line-height: 50px;
      text-align: center;
      // height: 70px;
      font-size: 22px;
      border-radius: 3rem;
      cursor: pointer;
      text-transform: uppercase;
      background-image: linear-gradient(
        -90deg,
        rgba(206, 60, 213, 0.73) 0%,
        rgba(138, 0, 145, 0.73) 100%
      ), linear-gradient(
        #8a0091,
        #8a0091
      );
      background-blend-mode: normal, normal;
      box-shadow: 0px 3px 7px 0px rgba(0, 0, 0, 0.35);
      border-radius: 8px;
    }

    +e(line) {
      display: flex;
      flex-flow: row;
      align-items: flex-start;
      width: 100%;

      +m(message) {
        display: flex;
        flex-flow: column;
        justify-content: center;
        align-items: center;
        font-size: 26px;
        color: #333333;
        z-index: 66;
        // background: url('../assets/images/crile.png') left top no-repeat;
        background-size: cover;
        padding: 1.5rem;
        background: #ffffff;
        border-radius: 0.9rem;
        margin: 1rem 0 4rem 2rem;
        position: relative;

        .angle {
          position: absolute;
          left: -25px;
          top: 1rem;
        }

        span {
          line-height: 3rem;
          text-align: center;

          &:nth-child(2n) {
            border-top: 2px solid #e5e5e5;
          }
        }
      }

      &.right {
        justify-content: flex-end;

        .content__line--message {
          // background: url('../assets/images/crile-right.png') left top no-repeat;
          // background-size: cover;
          margin: 0 2rem 0 0;

          .angle {
            left: auto;
            right: -25px;
            transform: rotateY(180deg);
            // transform: rotateX(180deg);
          }
        }
      }
    }
  }
}

+b(home) {
  +e(top1) {
    // padding: 0.9rem;
    height: 540px;
    background: url('../assets/images/topbg.jpg') center center no-repeat;
    background-size: cover;
    display: flex;
    flex-flow: column;

    .inner {
      .content {
        .globel {
          h2 {
            font-size: 50px;
            font-weight: bold;
            margin: 0.25rem 0;
          }

          span {
            font-size: 30px !important;
            font-weight: 400;
          }
        }
      }
    }
  }

  +e(tags) {
    background: url('../assets/images/tags.jpg') center center no-repeat;
    background-size: cover;
    height: 580px;
    margin: 3rem 0;
    display: flex;
    align-items: center;
    justify-content: center;

    .inner {
      .content {
        .tags {
          width: 50%;
          background: rgba(255, 255, 255, 0.6);
          padding: 0.9rem;
          display: flex;
          flex-flow: row;
          flex-wrap: wrap;

          li {
            list-style: none;
            width: 50%;
            display: flex;
            flex-flow: column;
            align-items: center;
            justify-content: center;
            margin: 0.9rem 0;
            font-family: 'MicrosoftYaHei';
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 0px;

            .title {
              font-size: 22px;
              color: #040404;
              margin-top: 0.5rem;
              line-height: 40px;
            }

            .desc {
              font-size: 14px;
              color: #040404;
            }
          }
        }
      }
    }
  }

  +e(people) {
    .inner {
      .content {
        .people-list {
          display: flex;
          flex-flow: row;
          justify-content: space-between;

          li {
            margin: 0 0.5rem;
          }
        }
      }
    }
  }

  +e(end) {
    background: url('../assets/images/bg-end.jpg') center center no-repeat;
    background-size: cover;
    height: 477px;

    .inner {
      height: 100%;
      display: flex;
      align-items: center;
      justify-content: center;

      .content {
        font-family: 'MicrosoftYaHei';
        font-stretch: normal;
        letter-spacing: 0px;

        .big {
          font-size: 36px;
          font-weight: bold;
          // line-height: 30px;
          margin-bottom: 0.9rem;
        }

        .small {
          font-size: 18px;
          font-weight: normal;
          // line-height: 30px;
          color: #ffffff;
        }
      }
    }
  }

  +e(last) {
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;

    .inner {
      height: 100%;

      .content {
        font-family: 'MicrosoftYaHei';
        font-stretch: normal;
        letter-spacing: 0px;
        padding: 5rem 0;

        .big {
          font-size: 36px;
          color: #000000;
          font-weight: bold;
          margin: 0.9rem 0;
        }

        .small {
          font-size: 16px;
          color: #000000;
          font-weight: bold;
        }
      }
    }
  }

  +e(footer) {
    margin-top: 3rem;
    display: flex;
    flex-flow: column;
    align-items: center;
    justify-content: center;
    padding: 2rem;

    .open {
      color: #8590a6;
      text-decoration: none;

      &:hover {
        color: #175199;
      }
    }

    span {
      display: flex;
      flex-flow: row;
      align-items: center;
      margin: 0.5rem;
      font-size: 18px;
      color: #333333;
    }

    img {
      width: 20px;
      object-fit: cover;
      margin-right: 0.5rem;
    }
  }
}
</style>
